import { Component } from '@angular/core';

@Component({
  selector: 'app-card-etapa-concluida',
  templateUrl: './card-etapa-concluida.component.html',
  styleUrl: './card-etapa-concluida.component.scss'
})
export class CardEtapaConcluidaComponent {

}
